import { ISupplierCardConfig } from 'src/packages/polaris/types/interviews';
import ArrowIcon from 'src/components/icons/Arrow';
import CheckmarkIcon from 'src/components/icons/Checkmark';
import DollarIcon from 'src/components/icons/Dollar';
import NoVideoIcon from 'src/components/icons/NoVideo';
import PillBottleIcon from 'src/components/icons/PillBottle';

type SupplierCardProps = {
  handleCtaClick?: () => void;
  supplierCtaCardConfig: ISupplierCardConfig;
};

export const ICONS = [
  { name: 'checkmark', component: CheckmarkIcon },
  { name: 'cost', component: DollarIcon },
  { name: 'noVideo', component: NoVideoIcon },
  { name: 'rxBottle', component: PillBottleIcon },
];

function formatHeader(header: string) {
  return header.toUpperCase();
}

const SupplierCard = ({ handleCtaClick, supplierCtaCardConfig }: SupplierCardProps) => {
  const { bulletPoints, ctaButton, description, header, subheader } = supplierCtaCardConfig || {};
  const headerText = formatHeader(header || '');

  const handleClick = () => {
    handleCtaClick?.();
    window.open(ctaButton?.url, '_blank');
  };

  return (
    <div className="bp-flex bp-flex-col bp-items-start bp-rounded bp-border-[1px] bp-border-solid bp-border-gray-10 bp-bg-orange-0 bp-p-6 bp-font-primary bp-text-gray-100">
      <div className="bp-text-xs bp-tracking-[0.075rem]">{headerText}</div>
      <div className="bp-py-2 bp-text-lg">{subheader}</div>
      <div className="bp-pb-4 bp-font-secondary bp-text-sm">{description}</div>
      <div>
        {bulletPoints?.map((bulletPoint, i) => {
          const Icon = ICONS.find((icon) => bulletPoint.icon === icon.name)?.component;
          return (
            <div
              className="bp-mb-2 bp-flex bp-items-center bp-gap-2 last:bp-mb-0"
              key={`${bulletPoint.text}-${i}`}
            >
              {Icon && (
                <span>
                  <Icon backgroundColor={'#FFFFFF'} color={'#E29727'} />
                </span>
              )}

              <span className="bp-pb-2 bp-text-sm last:bp-pb-0">{bulletPoint.text}</span>
            </div>
          );
        })}
      </div>
      <div className="bp-w-full bp-pt-4">
        <button
          type="button"
          className="bp-flex bp-w-full bp-items-center bp-justify-between bp-rounded-[1.875rem] bp-bg-orange-20 bp-px-6 bp-py-2 bp-shadow"
          onClick={handleClick}
        >
          <span>{ctaButton?.label}</span>
          <ArrowIcon />
        </button>
      </div>
    </div>
  );
};

export default SupplierCard;
